export { TableViewerNova } from './table-viewer-nova';
export type { TableViewerNovaProps } from './table-viewer-nova'; 